<template>
  <div id="home">
    <my-header></my-header>
    <div class="pd20">
      <h3 class="mt0">{{'Manage member in group'|translate}}</h3>
      <ul class="breadcrumb" v-if="item">
        <li>
          <router-link :to="{ name: 'ManageGroup'}">{{'Manage groups'|translate}}</router-link>
        </li>
        <li>{{item.name}}</li>
      </ul>
      <div class="row" v-if="item">
        <div class="col-md-5 mt20">
          <!-- <a class="btn btn-primary" v-on:click="showModal(null)">{{'Add member'|translate}}</a> -->

          <autocomplete
            ref="autocomplete"
            :placeholder="'Search' | translate"
            :source="distributionGroupsEndpoint"
            input-class="form-control"
            results-property="data"
            :results-display="formattedDisplay"
            :request-headers="authHeaders"
            @selected="selectedMember"
          ></autocomplete>
        </div>
        <!-- <div class="col-md-7 mt20">
          <input
            type="text"
            class="form-control"
            v-model="keyword"
            v-on:keypress.enter.prevent="search()"
            :placeholder="'Search'|translate"
          />
        </div>-->
      </div>

      <p
        class="mt20 alert alert-info"
        v-if="list_items && list_items.length == 0"
      >{{'There is no data'|translate}}</p>
      <table class="table mt10" v-if="list_items && list_items.length > 0">
        <thead>
          <tr>
            <th>{{'Avatar'|translate}}</th>
            <th>{{'Name'|translate}}</th>
            <th>{{'Phone'|translate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item) in list_items" :key="item.id">
            <td>
              <my-image :width="50" :height="50" :src="item.feature_image_path"></my-image>
            </td>
            <td>
              <router-link :to="{ name: 'EditGroup', params: { id: item.id }}">{{item.name}}</router-link>
            </td>

            <td>{{ item.phone }}</td>
          </tr>
        </tbody>
      </table>
      <paginate
        v-if="total_page > 1"
        :page-count="total_page"
        :click-handler="clickPage"
        :prev-text="'Prev'|translate"
        :next-text="'Next'|translate"
        v-model="page"
        :container-class="'pagination'"
      ></paginate>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/elements/Loading";
import selectlocation from "@/components/elements/SelectLocation";
import MyImage from "@/components/elements/MyImage";
import Paginate from "vuejs-paginate";
import Utils from "@/helpers/utils";
import MyHeader from "@/components/Layout/Header";
import Autocomplete from "vuejs-auto-complete";
//import GoogleAutocomplete from 'google-autocomplete-vue';
export default {
  name: "GroupMember",
  components: {
    Loading,
    selectlocation,
    MyHeader,
    Autocomplete,
    MyImage,
    Paginate
  },
  computed: {
    authHeaders() {
      return Utils.getHeader(this);
    }
  },
  data() {
    return {
      ready: false,
      working: false,
      removing: false,
      allProducts: [],
      keyword: "",
      page: 1,
      total_page: 1,
      item: null,
      list_items: null,
      src_image: "/static/images/no-photo.jpg",
      offset: 0,
      limit: Utils.getLimit()
    };
  },
  created() {
    // clone from original params
  },
  methods: {
    clickPage(pageNum) {
      console.log("pageNum", pageNum);
      this.offset = Utils.getNextOffset(pageNum, this.limit);
      this.list();
    },
    formattedDisplay(result) {
      let image_path = result.feature_image_path
        ? result.feature_image_path
        : this.src_image;
      return `<img src='${image_path}' width='50' height='50'/> ` + result.name;
    },
    showModal(data) {
      this.show_form = true;

      this.pass_data = data != null ? JSON.parse(JSON.stringify(data)) : data;

      setTimeout(() => {
        this.$refs.form.open();
      });
    },
    selectedMember(member) {
      this.$refs.autocomplete.clear();
      console.log("member", member);
      console.log("{ user_id: member.id }", {
        user_id: member.selectedObject.id
      });
      this.$alertify.confirmWithTitle(
        this.$t("Confirm"),
        this.$t("Are you sure to invite this user to group ?"),
        () => {
          this.working = true;
          Utils.request(this, true, "group")
            .post(`/members/${this.manage_id}`, {
              user_id: member.selectedObject.id
            })
            .then(response => {
              this.working = false;
              let data = response.data;
              if (data.status === "ok") {
                Utils.showSuccess(
                  this,
                  this.$t("Invitation is sent successfully")
                );
              } else {
                Utils.showError(this, data.data);
              }
            })
            .catch(error => {
              this.updating = false;
              Utils.showErrorMessage(this, error.response);
            });
        }
      );
    },
    distributionGroupsEndpoint(input) {
      return Utils.getRequestUrl("group") + "/search_members?q=" + input;
    },
    list() {
      let data = {
        offset: this.offset,
        limit: this.limit,
        id: this.manage_id
      };

      Utils.request(this, true, "group")
        .get(`/members/${this.manage_id}?${Utils.arrayToRequestParam(data)}`)
        .then(result => {
          console.log("result", result);
          this.list_items = result.data.data.list;
          console.log("result.data.data.total", result.data.data.total);
          this.total_page = Utils.getTotalPages(
            result.data.data.total,
            this.limit
          );
          console.log("this.list_items", this.list_items);
          console.log("this.total_page", this.total_page);
        });
    }

    // authHeaders() {
    //   let header = Utils.getHeader(this);
    //   console.log("header", header);
    //   return header;
    // },
    // formattedDisplay(result) {
    //   return result.name + " [" + result.groupId + "]";
    // }
  },
  mounted() {
    this.manage_id = this.$route.params.id;
    

    let wating = [];

    let data = {
      id: this.manage_id
    };
    console.log("data", data);
    wating.push(
      Utils.request(this, true, "group").get(
        `/manage/?${Utils.arrayToRequestParam(data)}`
      )
    );
    this.list();
    Promise.all(wating).then(values => {
      this.item = values[0].data.data.list[0];
      console.log("this.item", this.item);
      // this.init();
    });
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Group/GroupMember.vue